module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-cover-page",
    class: _vm.coverClass,
    style: ({
      'color': _vm.payload.cover.color,
      'background-color': _vm.payload.cover.backgroundColor,
      'font-family': _vm.payload.options.documentFont
    })
  }, [(_vm.payload.cover.backgroundImage) ? _c('span', {
    staticClass: "has-bg-img",
    style: ({
      'background-image': 'url(' + _vm.payload.cover.backgroundImage + ')'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "document-cover-page-content",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "company-logo",
    class: {
      hover: _vm.state === 'editor'
    }
  }, [(!_vm.payload.cover.logo && _vm.state === 'editor') ? _c('dropzone', {
    attrs: {
      "default-message": "Drag & drop your logo here or choose a file from your computer ... (optional)"
    },
    on: {
      "upload": _vm.updateLogo
    }
  }) : _vm._e(), _vm._v(" "), (_vm.payload.cover.logo && _vm.state !== 'preview') ? _c('span', {
    staticClass: "edit-wrapper"
  }, [_c('i', {
    staticClass: "icon icon-edit",
    on: {
      "click": function($event) {
        _vm.resetDropzone()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payload.cover.logo),
      expression: "payload.cover.logo"
    }],
    attrs: {
      "src": _vm.payload.cover.logo
    },
    on: {
      "click": function($event) {
        _vm.resetDropzone()
      }
    }
  })], 1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payload.cover.title),
      expression: "payload.cover.title"
    }],
    ref: "title",
    staticClass: "document-title-input",
    style: ({
      'color': _vm.payload.cover.color
    }),
    attrs: {
      "data-gramm": "false",
      "id": "document-title-input",
      "disabled": _vm.state !== 'editor'
    },
    domProps: {
      "value": (_vm.payload.cover.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payload.cover, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.payload.cover.client || _vm.state === 'editor') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payload.cover.client),
      expression: "payload.cover.client"
    }],
    ref: "client",
    staticClass: "client-input",
    style: ({
      'color': _vm.payload.cover.color
    }),
    attrs: {
      "data-gramm": "false",
      "id": "client-input",
      "placeholder": "Add company name...",
      "disabled": _vm.state !== 'editor'
    },
    domProps: {
      "value": (_vm.payload.cover.client)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payload.cover, "client", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.payload.cover.createdBy || _vm.state === 'editor') ? _c('span', {
    staticClass: "created-by"
  }, [_c('strong', {
    style: ({
      'color': _vm.payload.cover.color
    }),
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("Created by:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payload.cover.createdBy),
      expression: "payload.cover.createdBy"
    }],
    staticClass: "created-by-input",
    style: ({
      'color': _vm.payload.cover.color
    }),
    attrs: {
      "type": "text",
      "id": "created-by-input",
      "placeholder": "Jane Doe",
      "size": _vm.payload.cover.createdBy && _vm.payload.cover.createdBy.length > 20 ? _vm.payload.cover.createdBy.length : 20,
      "disabled": _vm.state !== 'editor'
    },
    domProps: {
      "value": (_vm.payload.cover.createdBy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payload.cover, "createdBy", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.payload.cover.createdFor || _vm.state === 'editor') ? _c('span', {
    staticClass: "created-for"
  }, [_c('strong', {
    style: ({
      'color': _vm.payload.cover.color
    }),
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("Created for:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payload.cover.createdFor),
      expression: "payload.cover.createdFor"
    }],
    staticClass: "created-for-input",
    style: ({
      'color': _vm.payload.cover.color
    }),
    attrs: {
      "type": "text",
      "id": "created-for-input",
      "placeholder": "Add recipient's name...",
      "size": _vm.payload.cover.createdFor && _vm.payload.cover.createdFor.length > 20 ? _vm.cover.createdFor.length : 20,
      "disabled": _vm.state !== 'editor'
    },
    domProps: {
      "value": (_vm.payload.cover.createdFor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payload.cover, "createdFor", $event.target.value)
      }
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99439fa6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/document-parts/cover.vue
// module id = 547
// module chunks = 0